export default __webpack_public_path__ + "static/media/usdc.17320896.svg";